// extracted by mini-css-extract-plugin
export var infoItem = "_qj-2";
export var title = "_qj-0";
export var value = "_qj-1";